export default __webpack_public_path__ + "static/media/Car.d3224879.svg";